import { Item } from "../../../cuckoo/analysis/network/items";
import { JoeDomains } from "../../../../@types";
import { domain, ip, url } from "./schema";

export const items: Record<JoeDomains, Item> = {
  domain: {
    title: "Domain",
    schema: domain,
    errorMsg: "No Domain records."
  },
  ip: {
    title: "IP",
    schema: ip,
    errorMsg: "No IP records."
  },
  url: {
    title: "URL",
    schema: url,
    errorMsg: "No URL records."
  }
};
